import { ZeroProvider } from "@rocicorp/zero/react";
import { type ReactNode, useMemo } from "react";

import { ZERO_SERVER_URL } from "@/env";
import { useLogin } from "@/hooks/use-login";
import { useZeroStatus } from "@/hooks/use-zero-status";
import { createMutators } from "@/zero/mutators";
import { schema } from "@/zero/schema";

export function ZeroInit({ children }: { children: ReactNode }) {
  const { user, jwt, logout } = useLogin();
  const { setIsOnline } = useZeroStatus();

  const props = useMemo(() => {
    return {
      schema,
      onOnlineChange: (online: boolean) => {
        setIsOnline(online);
      },
      server: ZERO_SERVER_URL,
      userID: user?.id ?? "anon",
      mutators: createMutators(),
      logLevel: "info" as const,
      auth: (error?: "invalid-token") => {
        if (error === "invalid-token") {
          console.error("Could not authenticate with zero, logging user out");
          logout();
          return undefined;
        }
        return jwt;
      },
    };
  }, [jwt, setIsOnline]);

  return <ZeroProvider {...props}>{children}</ZeroProvider>;
}
